import { render, staticRenderFns } from "./AddressValidatedBadge.vue?vue&type=template&id=7326bf6a"
import script from "./AddressValidatedBadge.vue?vue&type=script&lang=js"
export * from "./AddressValidatedBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports